import { useState, useRef, useMemo } from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  ClickAwayListener,
  Grid,
  useTheme,
} from '@mui/material';
import PassengersPicker from '../PassengerPicker';

export default function PassengersDropdown({
  lessThan70,
  lessThan75,
  moreThan75,
  managePassengers,
  hasError,
}) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const ignoreClickAway = useRef(false);

  const totalPassengers = lessThan70 + lessThan75 + moreThan75;

  const handleClick = () => {
    ignoreClickAway.current = true;
    setOpen(prev => !prev);
  };

  const handleClickAway = () => {
    if (ignoreClickAway.current) {
      ignoreClickAway.current = false;
      return;
    }
    setOpen(false);
  };

  const passengerItems = useMemo(
    () => [
      { label: 'Hasta 69 años', state: lessThan70, index: 1 },
      { label: 'De 70 a 74 años', state: lessThan75, index: 2 },
      { label: 'Más de 75', state: moreThan75, index: 3 },
    ],
    [lessThan70, lessThan75, moreThan75]
  );

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <Button
        variant="outlined"
        onClick={handleClick}
        disableRipple
        sx={{
          width: '100%',
          height: 55,
          borderRadius: 1,
          borderColor:
            hasError && totalPassengers === 0 ? 'red' : theme.primary,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 2,
          '&:hover': {
            borderColor: theme.tertiary,
            backgroundColor: '#eee',
          },
        }}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 600,
                color: '#636466',
                paddingLeft: '0px',
              }}
            >
              Pasajeros
            </Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ fontSize: 18, fontWeight: 600, pr: 1 }}>
              {totalPassengers}
            </Typography>
          </Grid>
        </Grid>
      </Button>

      {open && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper
            sx={{
              position: 'absolute',
              top: '100%',
              left: 0,
              width: '100%',
              bgcolor: '#fff',
              border: `1px solid ${theme.tertiary}`,
              borderRadius: 1,
              zIndex: 1300,
              pt: 1,
            }}
          >
            {passengerItems.map(item => (
              <Grid
                container
                key={item.index}
                alignItems="center"
                justifyContent="space-between"
                sx={{ py: 1, px: 2 }}
              >
                <Grid
                  item
                  xs={8}
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <Typography
                    sx={{ fontWeight: 600, fontSize: 15, color: 'black' }}
                  >
                    {item.label}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Box onClick={e => e.stopPropagation()}>
                    <PassengersPicker
                      passengerState={item.state}
                      passengerQuantity={action =>
                        managePassengers(action, item.index)
                      }
                    />
                  </Box>
                </Grid>
              </Grid>
            ))}
          </Paper>
        </ClickAwayListener>
      )}
    </Box>
  );
}
